const addExistingReducer = (state = {}, action) => {
    switch (action.type) {
      case "ADD_EXISTING": {
        return{
          ...state,
          addExistingSuccess: action.success
        }
      }
      case "ADD_EXISTING_ERR": {
        return{
          ...state,
          addExistingError: action.err
        }
      }
      default:
        return state;
    }
  };
  
  export default addExistingReducer;
  